module.exports = __webpack_public_path__ + "img/lightdisk.4e19249a.png";